import $axios from "../api/accessor";
import { $api } from "../api/api";
import { UpdateUserPayload, UsersFilterParams } from "../interfaces/admin.interface";

export const UsersService = {
  getUsers: async (filters: UsersFilterParams) => {
    const cleanParams: Record<string, any> = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      cleanParams[key] = value;
    });

    try {
      const response = await $axios.get($api("users", cleanParams));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },

  getUserById: async (id: number | string) => {
    try {
      const response = await $axios.get($api("get_user", { id }));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },

  updateUser: async (id: number | string, payload: UpdateUserPayload) => {
    try {
      const response = await $axios.post($api("update_user", { id }), payload);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },

  deleteUser: async (id: number | string) => {
    try {
      const response = await $axios.delete($api("delete_user", { id }));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      if (error?.response?.status === 405) {
        try {
          const postRes = await $axios.post($api("delete_user", { id }));
          return { data: postRes?.data, status: postRes?.status };
        } catch (postErr: any) {
          return {
            data: postErr?.response?.data || null,
            status: postErr?.response?.status || 500,
            error: postErr,
          };
        }
      }
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },
};
